module.exports = __webpack_public_path__ + "media/images/number_4_green-e59955a382ab6a695067dd4e28e04c26.png";